const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function computeInterviewSchedulingDeadline(createdAtIso: string): Date | null {
  const createdAt = new Date(createdAtIso);
  if (Number.isNaN(createdAt.getTime())) return null;

  // Inclusive date window: created on day 1 stays open through day 8 end-of-day.
  const startOfReachOutDayLocal = new Date(
    createdAt.getFullYear(),
    createdAt.getMonth(),
    createdAt.getDate(),
    0,
    0,
    0,
    0,
  );
  const endOfDaySevenLocal = new Date(
    startOfReachOutDayLocal.getTime() + 7 * MS_PER_DAY + (MS_PER_DAY - 1),
  );
  return endOfDaySevenLocal;
}

export function isInterviewSchedulingExpired(
  createdAtIso: string,
  now: Date = new Date(),
): boolean {
  const deadline = computeInterviewSchedulingDeadline(createdAtIso);
  if (!deadline) return true;
  return now.getTime() > deadline.getTime();
}

export function isWithinInterviewSchedulingWindow(
  createdAtIso: string,
  targetTime: Date,
): boolean {
  const deadline = computeInterviewSchedulingDeadline(createdAtIso);
  if (!deadline || Number.isNaN(targetTime.getTime())) return false;
  return targetTime.getTime() <= deadline.getTime();
}
